import { Button } from '@/components/ui/Button';
import { TRUST_MARKS } from '@/lib/content';
import './Hero.css';

export function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container hero__inner">
        <div className="hero__copy">
          <span className="hero__eyebrow">Early access · iOS &amp; Android</span>
          {/* The single H1 for the page. */}
          <h1>
            Caring for someone? You shouldn’t have to be the filing cabinet.
          </h1>
          <p className="hero__lead">
            The diagnosis lives in one place, the medications in another, appointments somewhere else
            again — and nobody but you is holding all of it. CareBee puts the whole picture in one app,
            and gives one family member the standing to act on it.
          </p>

          <div className="hero__actions">
            <Button as="a" href="#request-access" variant="honey" size="lg">
              Request access
            </Button>
            <Button as="a" href="#what-it-does" variant="ghost" size="lg">
              See what it does
            </Button>
          </div>

          <p className="hero__note">
            $20 a month for the household · Medical Power of Attorney included
          </p>

          <ul className="hero__marks">
            {TRUST_MARKS.map((mark) => (
              <li key={mark}>{mark}</li>
            ))}
          </ul>
        </div>

        <div className="hero__art" aria-hidden="true">
          <img src="/assets/logos/carebee-mark.svg" alt="" width={320} height={320} />
        </div>
      </div>
    </section>
  );
}
